import React from 'react'
import Select from 'react-select'
import ReactHtmlParser from 'html-react-parser'

class DoubleTextDropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      text1: '',
      text2: ''
    }
    this.handleDropdownChange = this.handleDropdownChange.bind(this)
    this.handleTextChange = this.handleTextChange.bind(this)
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index } = this.props
    if (rawAnswers) {
      this.setState(rawAnswers)
    } else {
      storeAnswer(index, this.state)
    }
  }

  handleDropdownChange(e) {
    const { storeAnswer, index, checkSurveyState } = this.props
    this.setState({ selected: e.value }, () => {
      storeAnswer(index, this.state)
      checkSurveyState(this)
    })
  }

  handleTextChange(e, input) {
    const { storeAnswer, index, checkSurveyState } = this.props
    const obj = {}
    obj[input] = e.target.value
    this.setState(obj, () => {
      storeAnswer(index, this.state)
      checkSurveyState(this)
    })
  }

  render() {
    const {
      text1,
      text2,
      question,
      dropdown,
      isTimeOfDay,
      className
    } = this.props
    const options = []
    dropdown.options.forEach(option => {
      options.push({ value: option, label: option })
    })

    return (
      <div className={`${className}`}>
        <div className="surveys-intro row collapse">
          <div className="small-12 columns">
            <h3>{ReactHtmlParser(question)}</h3>
          </div>
        </div>
        <div className="row surveys-container collapse">
          <div className="surveys-list small-12 columns">
            <div className={`survey-label survey-item-${text1.size}`}>
              {text1.label}
            </div>
            {isTimeOfDay ? <span style={{ opacity: 0 }}>:</span> : null}
            <div className={`survey-label survey-item-${text2.size}`}>
              {text2.label}
            </div>
            <div className={`survey-label survey-item-${dropdown.size}`}>
              {dropdown.label}
            </div>

            <br />
            <input
              type="text"
              placeholder="Type Here..."
              onChange={e => this.handleTextChange(e, 'text1')}
              value={this.state.text1}
              className={`survey-text survey-item-${text1.size}`}
            />
            {isTimeOfDay ? <span>:</span> : null}
            <input
              type="text"
              placeholder="Type Here..."
              onChange={e => this.handleTextChange(e, 'text2')}
              value={this.state.text2}
              className={`survey-text survey-item-${text2.size}`}
            />
            <Select
              options={options}
              className={`survey-dropdown survey-item-${dropdown.size}`}
              onChange={this.handleDropdownChange}
              value={this.state.selected}
              clearable={false}
              searchable={false}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default DoubleTextDropdown
